import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, vModelText as _vModelText, resolveDynamicComponent as _resolveDynamicComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "public-nodes-menu-wrap"
}
const _hoisted_2 = { class: "public-nodes-menu" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "top-search-wrap"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "top-right" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "top-quick-add"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 6,
  class: "quick-add-toast",
  role: "status"
}
const _hoisted_11 = { id: "app-main" }
const _hoisted_12 = {
  key: 0,
  class: "mobile-nav-show-hide"
}
const _hoisted_13 = {
  key: 0,
  style: {"height":"40px","min-height":"40px"}
}
const _hoisted_14 = { class: "nav-show-hide" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "nav-main" }
const _hoisted_17 = {
  key: 0,
  style: {"margin-top":"10px","padding-right":"40px"}
}
const _hoisted_18 = ["value"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "menu-subhead"
}
const _hoisted_22 = {
  class: "mobile-991",
  style: {"margin-top":"25px"}
}
const _hoisted_23 = {
  class: "content",
  id: "main-content"
}
const _hoisted_24 = {
  key: 0,
  id: "lds-wrapper"
}
const _hoisted_25 = {
  key: 8,
  class: "error-msg-wrap"
}
const _hoisted_26 = {
  class: "error-msg",
  style: {"width":"auto"}
}
const _hoisted_27 = { style: {"margin-bottom":"15px"} }
const _hoisted_28 = {
  key: 9,
  style: {"position":"fixed","bottom":"10px","left":"10px"}
}
const _hoisted_29 = {
  key: 10,
  style: {"position":"fixed","bottom":"10px","left":"10px"}
}
const _hoisted_30 = {
  key: 11,
  class: "support-bar",
  role: "status"
}
const _hoisted_31 = {
  key: 17,
  class: "error-msg-wrap"
}
const _hoisted_32 = { class: "error-msg" }
const _hoisted_33 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_top_search = _resolveComponent("top-search")!
  const _component_user_switch = _resolveComponent("user-switch")!
  const _component_user_sub_menu = _resolveComponent("user-sub-menu")!
  const _component_floating_timer = _resolveComponent("floating-timer")!
  const _component_ask_forge = _resolveComponent("ask-forge")!
  const _component_quick_add_task = _resolveComponent("quick-add-task")!
  const _component_quick_add_agenda_item = _resolveComponent("quick-add-agenda-item")!
  const _component_my_numbers = _resolveComponent("my-numbers")!
  const _component_nav_item = _resolveComponent("nav-item")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_task_reminders = _resolveComponent("task-reminders")!
  const _component_team_hub_role_col = _resolveComponent("team-hub-role-col")!
  const _component_team_hub_sheet = _resolveComponent("team-hub-sheet")!
  const _component_pdf_pop_up = _resolveComponent("pdf-pop-up")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app-wrap",
    class: _normalizeClass(_ctx.loadedInit ? '' : 'app-hide')
  }, [
    _createElementVNode("div", null, [
      (_ctx.showAllNodesMenu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.allNodesFiltered, (next, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createElementVNode("a", {
                    onClick: _withModifiers(($event: any) => (_ctx.handleNode(next)), ["prevent"])
                  }, [
                    _createTextVNode(_toDisplayString(next.TypesString || 'Node') + ": ", 1),
                    _createElementVNode("b", null, _toDisplayString(next.Name), 1)
                  ], 8, _hoisted_3)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.$store.state.signedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              to: "/playbook/home",
              class: "top-logos"
            }, {
              default: _withCtx(() => [
                _cache[27] || (_cache[27] = _createElementVNode("img", { src: "https://superform-portal.nyc3.digitaloceanspaces.com/playbook_logos/logo-light.png" }, null, -1)),
                (_ctx.$store.state.user.logoPath)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.$store.state.spacesUrlPublic + _ctx.$store.state.user.logoPath
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_top_search),
            _createVNode(_component_user_switch)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["top-timer-btn", [ _ctx.$store.state.timer.status, _ctx.$store.state.timer.open ? 'open' : '', _ctx.$store.state.timer.label && !_ctx.$store.state.timer.open ? 'counting' : '' ]]),
              title: "Timer",
              "aria-label": "Timer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.state.timer.open = !_ctx.$store.state.timer.open))
            }, [
              _cache[28] || (_cache[28] = _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                "aria-hidden": "true"
              }, [
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "13",
                  r: "8"
                }),
                _createElementVNode("path", { d: "M12 9v4l2.5 2.5M10 2h4M12 2v3" })
              ], -1)),
              (_ctx.$store.state.timer.label && !_ctx.$store.state.timer.open)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$store.state.timer.label), 1))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.$store.state.user.employeeID)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn top-quick-btn",
                    title: "Add a task to your task manager",
                    "aria-label": "Add task",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.state.quickAdd = 'task'))
                  }, [...(_cache[29] || (_cache[29] = [
                    _createElementVNode("svg", {
                      class: "top-quick-icon",
                      viewBox: "0 0 24 24",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("rect", {
                        x: "3",
                        y: "3",
                        width: "18",
                        height: "18",
                        rx: "3"
                      }),
                      _createElementVNode("path", { d: "M8 12.5l3 3 5-6" })
                    ], -1),
                    _createElementVNode("span", null, "Task", -1)
                  ]))]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-light top-quick-btn",
                    title: "Add an agenda item to a meeting",
                    "aria-label": "Add agenda item",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$store.state.quickAdd = 'agenda'))
                  }, [...(_cache[30] || (_cache[30] = [
                    _createStaticVNode("<svg class=\"top-quick-icon\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M9 6h11M9 12h11M9 18h11\"></path><circle cx=\"4.5\" cy=\"6\" r=\"1\"></circle><circle cx=\"4.5\" cy=\"12\" r=\"1\"></circle><circle cx=\"4.5\" cy=\"18\" r=\"1\"></circle></svg><span>Agenda</span>", 2)
                  ]))]),
                  (_ctx.$store.state.numbersToEnter)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn-light top-quick-btn",
                        title: 'Enter your scorecard numbers (' + _ctx.$store.state.numbersToEnter + ' to enter)',
                        "aria-label": "Enter scorecard numbers",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$store.state.quickAdd = 'numbers'))
                      }, [...(_cache[31] || (_cache[31] = [
                        _createElementVNode("svg", {
                          class: "top-quick-icon",
                          viewBox: "0 0 24 24",
                          "aria-hidden": "true"
                        }, [
                          _createElementVNode("path", { d: "M3 20h18M6 20v-6M12 20V5M18 20v-9" })
                        ], -1),
                        _createElementVNode("span", null, "Numbers", -1)
                      ]))], 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.canForge)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/ai-hub",
                  class: "ai-btn top-forge-btn",
                  title: "The Forge"
                }, {
                  default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                    _createElementVNode("svg", {
                      "aria-hidden": "true",
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "15",
                      height: "15",
                      viewBox: "0 0 24 24",
                      fill: "currentColor",
                      "fill-rule": "evenodd"
                    }, [
                      _createElementVNode("path", { d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z" })
                    ], -1),
                    _createElementVNode("span", null, "The Forge", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_user_sub_menu)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.signedIn)
      ? (_openBlock(), _createBlock(_component_floating_timer, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.loadedInit && _ctx.$store.state.signedIn && !_ctx.isEmbedded)
      ? (_openBlock(), _createBlock(_component_ask_forge, {
          key: _ctx.$store.state.user.companyID
        }))
      : _createCommentVNode("", true),
    (_ctx.$store.state.quickAdd == 'task')
      ? (_openBlock(), _createBlock(_component_quick_add_task, {
          key: 3,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$store.state.quickAdd = null))
        }))
      : _createCommentVNode("", true),
    (_ctx.$store.state.quickAdd == 'agenda')
      ? (_openBlock(), _createBlock(_component_quick_add_agenda_item, {
          key: 4,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$store.state.quickAdd = null))
        }))
      : _createCommentVNode("", true),
    (_ctx.$store.state.quickAdd == 'numbers')
      ? (_openBlock(), _createBlock(_component_my_numbers, {
          key: 5,
          popup: "",
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$store.state.quickAdd = null))
        }))
      : _createCommentVNode("", true),
    (_ctx.$store.state.quickAddToast)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$store.state.quickAddToast.text), 1),
          (_ctx.$store.state.quickAddToast.link)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.openQuickAddLink()), ["prevent"]))
              }, _toDisplayString(_ctx.$store.state.quickAddToast.link.label), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "quick-add-toast-x",
            "aria-label": "Dismiss",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$store.state.quickAddToast = null))
          }, [...(_cache[33] || (_cache[33] = [
            _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
              _createElementVNode("path", { d: "M6 6l12 12M18 6L6 18" })
            ], -1)
          ]))])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.$store.state.signedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("span", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggleMenu()))
            }, [...(_cache[34] || (_cache[34] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", { d: "M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z" })
              ], -1)
            ]))])
          ]))
        : _createCommentVNode("", true),
      (_ctx.$store.state.signedIn)
        ? (_openBlock(), _createElementBlock("nav", {
            key: 1,
            class: _normalizeClass(_ctx.showMenu ? 'show-nav' : 'hide-nav')
          }, [
            (!_ctx.showMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", {
                innerHTML: _ctx.showMenu ? `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="svg-inline--fa fa-chevron-left fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="svg-inline--fa fa-chevron-left fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg>` : `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" class="svg-inline--fa fa-chevron-right fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" class="svg-inline--fa fa-chevron-right fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>`,
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleMenu()))
              }, null, 8, _hoisted_15)
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_ctx.showMenu && _ctx.$store.state.user.allCompanies && _ctx.$store.state.user.allCompanies.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.$store.state.user.companyID) = $event)),
                      onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.switchCompany()))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.allCompanies, (c, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: i,
                          value: c.companyID
                        }, _toDisplayString(c.name), 9, _hoisted_18))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.$store.state.user.companyID]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navSections, (section) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: section.name
                  }, [
                    _createElementVNode("div", {
                      class: "menu-head",
                      onClick: () => { _ctx.$store.state.adminSelectedMenu = section.name }
                    }, _toDisplayString(section.name), 9, _hoisted_19),
                    (_ctx.$store.state.adminSelectedMenu == section.name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.entries, (entry, i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: (entry.key || entry.subhead || 'favorites') + '-' + i
                            }, [
                              (entry.favorites)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.favoriteItems, (item) => {
                                    return (_openBlock(), _createBlock(_component_nav_item, {
                                      key: 'fav-' + item.key,
                                      item: item,
                                      favorite: true,
                                      "show-star": _ctx.showMenu,
                                      onToggleFavorite: _ctx.toggleFavorite
                                    }, null, 8, ["item", "show-star", "onToggleFavorite"]))
                                  }), 128))
                                : (entry.subhead)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(entry.subhead), 1))
                                  : (_openBlock(), _createBlock(_component_nav_item, {
                                      key: 2,
                                      item: entry,
                                      favorite: _ctx.$store.state.navFavorites.includes(entry.key),
                                      "show-star": _ctx.showMenu,
                                      onToggleFavorite: _ctx.toggleFavorite
                                    }, null, 8, ["item", "favorite", "show-star", "onToggleFavorite"]))
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.$store.state.user.userToPublic)
                    ? (_openBlock(), _createBlock(_component_user_switch, {
                        key: 0,
                        style: {"margin-bottom":"15px"}
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.$store.state.user.returnAdminID && !_ctx.$store.state.user.supportSession)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _cache[13] || (_cache[13] = _withModifiers(() => { _ctx.$store.state.showChangePassword = true; }, ["prevent"]))
                      }, "Change Password"))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.logOut()), ["prevent"]))
                  }, "Log Out")
                ])
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        (!_ctx.$store.state.routeLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[35] || (_cache[35] = [
              _createElementVNode("div", {
                id: "lds",
                class: "lds-ring"
              }, [
                _createElementVNode("div"),
                _createElementVNode("div"),
                _createElementVNode("div"),
                _createElementVNode("div")
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.loadedInit)
          ? _withDirectives((_openBlock(), _createBlock(_component_router_view, {
              key: _ctx.$route.path
            })), [
              [_vShow, _ctx.$store.state.routeLoaded]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.loadedInit && _ctx.$store.state.signedIn && _ctx.$store.state.user.employeeID && !_ctx.isEmbedded)
      ? (_openBlock(), _createBlock(_component_task_reminders, {
          key: _ctx.$store.state.user.employeeID
        }))
      : _createCommentVNode("", true),
    (_ctx.$store.state.showChangePassword)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _cache[36] || (_cache[36] = _createElementVNode("div", { style: {"font-size":"24px"} }, "Enter a new password", -1)),
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                placeholder: "Password",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newPasswordInput) = $event))
              }, null, 512), [
                [_vModelText, _ctx.newPasswordInput]
              ])
            ]),
            _createElementVNode("div", {
              onClick: _cache[16] || (_cache[16] = () => { _ctx.$store.state.showChangePassword = false }),
              class: "btn-invert",
              style: {"margin-right":"10px"}
            }, "Cancel"),
            _createElementVNode("div", {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.submitPasswordChange())),
              class: "btn",
              style: {"margin-left":"10px"}
            }, "Submit")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.user.role == 'public')
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", {
            class: "btn",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.returnToAdmin()))
          }, "Return to Admin")
        ]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.user.returnAdminID)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("div", {
            class: "btn",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.signBackToAdmin()))
          }, "Return to Admin")
        ]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.user.supportSession)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("span", null, [
            _cache[37] || (_cache[37] = _createElementVNode("b", null, "Support session", -1)),
            _createTextVNode(" · " + _toDisplayString(_ctx.$store.state.user.supportSession.by) + " as " + _toDisplayString(_ctx.$store.state.user.firstName) + " " + _toDisplayString(_ctx.$store.state.user.lastName) + " at " + _toDisplayString(_ctx.$store.state.user.companyName), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.endSupportSession()))
          }, "End Support Session")
        ]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.showRoleCol)
      ? (_openBlock(), _createBlock(_component_team_hub_role_col, {
          key: 12,
          onClose: _cache[21] || (_cache[21] = () => { _ctx.$store.state.showRoleCol = false }),
          slug: _ctx.$store.state.RoleSheetSlug,
          colID: _ctx.$store.state.RoleSheetColID
        }, null, 8, ["slug", "colID"]))
      : _createCommentVNode("", true),
    (_ctx.showTeamHubRoleCol)
      ? (_openBlock(), _createBlock(_component_team_hub_role_col, {
          key: 13,
          onClose: _cache[22] || (_cache[22] = () => { _ctx.showTeamHubRoleCol = false }),
          slug: _ctx.$store.state.user.teamHubEmployee.RoleSheetSlug,
          colID: _ctx.$store.state.user.teamHubEmployee.RoleSheetColID
        }, null, 8, ["slug", "colID"]))
      : _createCommentVNode("", true),
    (_ctx.showTeamHubSheet)
      ? (_openBlock(), _createBlock(_component_team_hub_sheet, {
          key: 14,
          id: _ctx.teamHubSheetID,
          onClose: _cache[23] || (_cache[23] = () => { _ctx.showTeamHubSheet = false })
        }, null, 8, ["id"]))
      : _createCommentVNode("", true),
    (_ctx.showPopUp)
      ? (_openBlock(), _createBlock(_component_pdf_pop_up, {
          key: 15,
          url: _ctx.popUpLink,
          onClose: _cache[24] || (_cache[24] = () => _ctx.showPopUp = false)
        }, null, 8, ["url"]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.showTeamHubChecklist)
      ? (_openBlock(), _createBlock(_component_pdf_pop_up, {
          key: 16,
          url: `/playbook/${_ctx.$store.state.selectedTeamHubChecklist}?hideNav=t&hideComponent=t&hideChat=t&fullChecklist=t`,
          onClose: _cache[25] || (_cache[25] = () => _ctx.$store.state.showTeamHubChecklist = false)
        }, null, 8, ["url"]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.showErrorMsg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", {
              innerHTML: _ctx.$store.state.errorMsg
            }, null, 8, _hoisted_33),
            _createElementVNode("div", {
              onClick: _cache[26] || (_cache[26] = () => _ctx.$store.state.showErrorMsg = false),
              class: "btn"
            }, "OK")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.user.primaryColor)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent('style'), { key: 18 }, {
          default: _withCtx(() => [
            _createTextVNode(" :root { --primary-color: " + _toDisplayString(_ctx.$store.state.user.primaryColor) + "; } ", 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.hideNav)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent('style'), { key: 19 }, {
          default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
            _createTextVNode(" .top-bar-wrap { display: none !important; } .mobile-nav-show-hide { display: none !important; } nav.show-nav, nav.hide-nav { display: none !important; } #app-main { max-height: 100vh !important; } #playbook-back-btn-wrap { display: none !important; } .public-nodes-menu-toggle { display: none !important; } #main-content { padding-top: 0 !important; } .page-bar { display: none !important; } .content { height: 100vh !important; } .top-search-wrap { display: none !important; } ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.hideNavOS)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent('style'), { key: 20 }, {
          default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
            _createTextVNode(" .top-bar-wrap { display: none !important; } .mobile-nav-show-hide { display: none !important; } nav.show-nav, nav.hide-nav { display: none !important; } #app-main { max-height: 100vh !important; } #playbook-back-btn-wrap { display: none !important; } .public-nodes-menu-toggle { display: none !important; } #main-content { padding-top: 0 !important; } .content { height: 100vh !important; } .top-search-wrap { display: none !important; } ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.$store.state.signedIn)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent('style'), { key: 21 }, {
          default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
            _createTextVNode(" .content { height: calc(100vh - 59px); } ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.showMenu)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent('style'), { key: 22 }, {
          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
            _createTextVNode(" @media(min-width: 1025px) { .fixed-submit { left: 70px; } .node-admin-component { left: 70px } } ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isEmbedded)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent('style'), { key: 23 }, {
          default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
            _createTextVNode(" .top-bar-wrap { display: none !important; } #app-main { max-height: 100vh; } .page-bar { padding-left: 25px !important; padding-right: 25px !important; } ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.$route.query.hideComponent)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent('style'), { key: 24 }, {
          default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
            _createTextVNode(" .node-admin-component, .rec-rail { display: none !important; } ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.$route.query.hideChat || _ctx.$store.state.hideChatWidget)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent('style'), { key: 25 }, {
          default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
            _createTextVNode(" #pb-widget-btn, .af-launch { display: none !important; } ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}